import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class PopupPortal extends React.Component {
  componentDidMount() {
    if (this.props.usePopupPortal && this.props.preventBodyScroll) {
      // Store the original overflow style
      const body = document.querySelector('body');
      if (body) {
        body.classList.add('overflowhidden');
      }
      // Prevent body scroll
    }
  }

  componentWillUnmount() {
    if (this.props.usePopupPortal && this.props.preventBodyScroll) {
      // Restore the original overflow style
      const body = document.querySelector('body');
      if (body) {
        body.classList.remove('overflowhidden');
      }
    }
  }

  render() {
    // Use a portal to render the children into the element

    return this.props.usePopupPortal
      ? ReactDOM.createPortal(
          // Any valid React child: JSX, strings, arrays, etc.
          this.props.children,
          // A DOM element
          document.querySelector(
            this.props.wrapper ? this.props.wrapper : '.popupWrapper',
          ),
        )
      : this.props.children;
  }
}
PopupPortal.propTypes = {
  usePopupPortal: PropTypes.bool,
  preventBodyScroll: PropTypes.bool,
  wrapper: PropTypes.string,
  children: PropTypes.node.isRequired,
};
PopupPortal.defaultProps = {
  usePopupPortal: false,
  preventBodyScroll: false,
  wrapper: '.popupWrapper',
};

export default PopupPortal;
